<template>
  <div class="d-flex flex-column" :style="`max-height: calc(${h}px - ${$vuetify.breakpoint.mobile ? 28 : 48}px);`">
    <div ref="scrollContainer" v-prevent-space-scroll style="overflow-y: scroll; flex-shrink: 1;" class="pt-4">
      <FilterGame
        v-for="(game, i) in games"
        :game="game"
        :key="game.game.id"
        :index="i"
      ></FilterGame>

      <!-- Pagination buttons -->
      <div v-if="has_more_games" class="d-flex justify-center mt-4 mb-2">
        <v-btn
          type="button"
          :loading="loading_more_games"
          :disabled="loading_more_games"
          :small="!$vuetify.breakpoint.mobile"
          :x-small="$vuetify.breakpoint.mobile"
          outlined
          @click="handleLoadMoreGames"
          class="mr-2"
        >
          Hae lisää
        </v-btn>
        <v-btn
          type="button"
          :loading="loading_more_games"
          :disabled="loading_more_games"
          :small="!$vuetify.breakpoint.mobile"
          :x-small="$vuetify.breakpoint.mobile"
          outlined
          @click="handleLoadAllGames"
        >
          Hae kaikki
        </v-btn>
      </div>
    </div>
    <div v-if="!$vuetify.breakpoint.mobile">
      <v-divider></v-divider>
      <QualityControlPanel v-if="$route.query.quality_control === 'true'" />
      <FilterMap v-else-if="showFilterMap" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import FilterGame from './FilterGame.vue'
import FilterMap from './FilterMap.vue'
import QualityControlPanel from '@/components/quality/QualityControlPanel.vue'
import { getSeasonYear, newRulesApply } from '@/utils/filterItems.js'

export default {
  components: { FilterGame, FilterMap, QualityControlPanel },
  props: ['events', 'playingEvent', 'leagueFilter', 'h'],
  data: () => ({
    chosenMapBaseId: null,
    mapVisible: true
  }),
  created() {
    // Listen for scroll-to-event from the store
    this.handleScrollToEvent = (event) => {
      this.scrollToEvent(event.detail.eventId)
    }
    window.addEventListener('scroll-to-event', this.handleScrollToEvent)

    // Seasons are needed to resolve whether the nyp map should be shown
    if(this.currentLeagueName === 'nyp' && (!this.seasons || !this.seasons.length)) {
      this.initSeasons(this.leagueId)
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll-to-event', this.handleScrollToEvent)
  },
  methods: {
    showMap(base) {
      return (this.chosenMapBaseId == base.id || this.currentClipUniqueBases.length < 2) && this.mapVisible
    },
    downloadMap() {
      this.$refs.map[0].downloadMap()
    },
    scrollToEvent(eventId) {
      this.$nextTick(() => {
        // Find the event element by data attribute
        const eventElement = document.querySelector(`[data-event-id="${eventId}"]`)
        if (eventElement && this.$refs.scrollContainer) {
          const container = this.$refs.scrollContainer
          const containerRect = container.getBoundingClientRect()
          const elementRect = eventElement.getBoundingClientRect()

          // Calculate the scroll position to center the element
          const scrollTop = container.scrollTop + elementRect.top - containerRect.top - (containerRect.height / 2) + (elementRect.height / 2)

          container.scrollTo({
            top: scrollTop,
            behavior: 'smooth'
          })
        }
      })
    },
    handleLoadMoreGames(event) {
      event.preventDefault()
      event.stopPropagation()

      console.log('Loading more games...')
      const id = this.$route.params.id || this.$route.query.event_id
      const query_filter = this.$route.query.filter

      this.loadMoreGames({
        id,
        filter: query_filter
      }).catch((error) => {
        console.error('Error loading more games:', error)
        this.$store.dispatch('noti/error', 'Virhe lisäpelien lataamisessa')
      })
    },
    handleLoadAllGames(event) {
      event.preventDefault()
      event.stopPropagation()

      const id = this.$route.params.id || this.$route.query.event_id
      const query_filter = this.$route.query.filter

      this.loadAllGames({
        id,
        filter: query_filter
      }).catch((error) => {
        console.error('Error loading all games:', error)
        this.$store.dispatch('noti/error', 'Virhe kaikkien pelien lataamisessa')
      })
    },
    ...mapActions('tag', [
      'initTags',
      'initLeagueTags'
    ]),
    ...mapActions('filter', [
      'loadMoreGames',
      'loadAllGames'
    ]),
    ...mapActions('admin', [
      'initSeasons'
    ])
  },
  computed: {
    ...mapGetters('filter', [
      'games',
      'filter',
      'has_more_games',
      'loading_more_games'
    ]),
    ...mapGetters('user', [
      'currentLeagueName',
      'leagueId'
    ]),
    ...mapGetters('admin', [
      'seasons',
      'season_by_id'
    ]),
    showFilterMap() {
      // From the 2026 season onwards the map is also shown for nyp
      if(this.currentLeagueName !== 'nyp') return true
      const season = this.season_by_id(this.filter?.season)
      return newRulesApply(getSeasonYear(season))
    },
    allPoints() {
      let pointsArr = this.events?.map(e => e.clips?.map(c => c.points)).flat(Infinity)
      return pointsArr
    },
    currentClipUniqueBases() {
      let bases = []
      this.allPoints.forEach(p => {
        if(!bases.map(b => b.id).includes(p.map_base_id)) {
          let base = {
            id: p.map_base_id,
            url: p.url
          }
          bases.push(base)
        }
      })

      return bases
    },
  }
}
</script>

<style lang="scss" scoped>
.io-game {
  &-title {
    color: grey;
    text-align: center;
    font-size: 1.2em;
  }

  &-clip {
    text-align: center;
    margin: 0px 5px 0px 5px;
    border-radius: 4px;
    border-left: 5px solid rgb(255, 255, 255, 0);

    &:hover {
      background-color: rgb(96, 164, 188);
      cursor: pointer;
    }
  }
}

.chosen {
  border-left: 5px solid rgb(76, 133, 154);
}
</style>